import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sizePage } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private readonly http: HttpClient
  ) { }

  GetList(pData: any, page: number): Observable<any> {
    page--;
    let url = '/auth/user/page/'
      + page + '?size=' + sizePage
      + '&' + pData;

    console.log(url);
    return this.http.get<any>(url, { observe: 'response' });
  }
  //{{url}}/assistance/person/self/all?filter=creationDate@bt::2024-11-01T00:00:00-06:00%232025-01-31T23:59:59-06:00,companyId::129&sort=name::asc&page=0&size=20
  public async getAllUser(idCompany: any, branchId: any, filter: string) {
    console.log(filter);
    //const url = `/assistance/person/self/all?filter=companyId::${idCompany},branchId::${branchId},platformId@lk::${filter}&page=0&sort=creationDate::desc&size=5000`;
    const url = `/assistance/person/self/all?filter=companyId::${idCompany},branchId::${branchId},name@lk::${filter}&page=0&sort=creationDate::desc&size=5000`;
    console.log(url);
    const response = await this.http.get(url).toPromise();

    console.log(response);
    return response;
  }

}
